module.exports = __webpack_public_path__ + "static/media/member2.2da22c0a.jpg";